// src/design/forms/datepicker/core/models/model.ts
var e = /* @__PURE__ */ function(e) {
	return e.SINGLE = "single", e.RANGE = "range", e.WEEK = "week", e;
}({}), t = /* @__PURE__ */ function(e) {
	return e.CALENDAR_VIEW = "CALENDAR_VIEW", e.MONTH_VIEW = "MONTH_VIEW", e.YEAR_VIEW = "YEAR_VIEW", e;
}({});
export { e as ModeEnum, t as ViewModeEnum };

//# sourceMappingURL=model.js.map